import React, { useState, useEffect } from "react";
import { Card, Row, Col, Avatar, Collapse, Tag, Spin, Space } from "antd";
import { LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { DashboardService } from "./services/dashboard-service";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";
import { useId24 } from "../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../config/app-config";
import { numberWithCommas } from "../../utils";
const appConfig = loadAppConfig();
interface Props {
  baseUrl: string;
}

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const DashboardManagerBank: React.FC<Props> = ({ baseUrl }) => {
  const [loading, setLoading] = useState<boolean>(true);

  const fontStyleHerder = {
    fontSize: "18px",
    color: "#FFFFFF",
  } as any;

  const fontStyleTap = {
    fontSize: "14px",
    borderRadius: "24px",
  } as any;

  const fontStyleRow = {
    textAlign: "left",
    fontSize: "10px",
    borderBottom: "1px solid #ddd",
  } as any;

  const history = useHistory();
  const { id24Axios } = useId24();
  const [dataSource, setDataSource] = useState<{
    new: any[];
    action: any[];
    noAction: any[];
  }>({
    new: [],
    action: [],
    noAction: [],
  });

  const toDebt = (status: string, team: string, list: string, oaName: string, oaCode: string) => {
    if (status) {
      let all = {
        type: "BANK",
        statusName: status,
        teamId: team,
        listName: list,
        oaName: oaName,
        oaCode: oaCode,
      };
      history.push("/debtmanagement", all);
    }
  };

  function integrateDashboardByStatus(data: any[], status: "new" | "action" | "noAction") {
    let listNew: any[] = [];
    let teamList: any[] = [];
    let dataSource: any[] = [];

    data.forEach((x1: any) => {
      if (x1.actionStatus === status) {
        listNew.push({
          listName: x1.listName,
          oaCode: x1.oaCode,
          oaname: x1.oaname,
          cnt: x1.cnt,
          sumamt: x1.sumamt,
          sumcurbal: x1.sumcurbal,
          sumstmtamt: x1.sumstmtamt,
          sumos: x1.sumos,
          teamName: x1.teamName,
          teamId: x1.teamId,
        });

        teamList.push({
          teamName: x1.teamName,
          teamId: x1.teamId,
          listName: x1.listName,
        });
      }
    });

    const groupByList = listNew.reduce((list: any[], groupList: any) => {
      const { teamName, listName } = groupList;
      const getGroup = list.find((x: any) => x.teamName === teamName && x.listName === listName);
      if (getGroup) {
        getGroup.oalist.push(groupList);
      } else {
        list.push({
          teamName,
          listName,
          oalist: [groupList],
        });
      }
      return list;
    }, []);

    const groupByTeamsForCheck = (teamList: any[]) =>
      Object.values(
        teamList.reduce((data: any, { teamName, listName }: any) => {
          if (!data[teamName]) {
            data[teamName] = { teamName, list: [] };
          }

          if (!data[teamName].list.find((l: any) => l.listName === listName)) {
            const oaList = groupByList.find((l: any) => l.listName === listName && l.teamName === teamName);
            data[teamName].list.push({ listName, oaList, teamName });
          }

          return data;
        }, {}),
      );

    const groupByTeams = (teamList: any[]) =>
      Object.values(
        teamList.reduce((data: any, { teamName, teamId, listName }: any) => {
          const oaList: any = groupByList.find((l: any) => l.listName === listName && l.teamName === teamName);

          let ac = 0,
            os = 0,
            bal = 0,
            cur = 0,
            stmt = 0;

          oaList.oalist.forEach((item: any) => {
            ac += item.cnt;
            os += item.sumos;
            bal += item.sumamt;
            cur += item.sumcurbal;
            stmt += item.sumstmtamt;
          });

          if (!data[teamName]) {
            let acTeam = 0,
              osTeam = 0,
              balTeam = 0,
              stmtTeam = 0,
              curTeam = 0;

            const teamListCheck: any = groupByTeamsForCheck(teamList).find((team: any) => team.teamName === teamName);

            teamListCheck.list.forEach((oaCount: any) => {
              oaCount.oaList.oalist.forEach((oa: any) => {
                acTeam += oa.cnt;
                osTeam += oa.sumos;
                balTeam += oa.sumamt;
                stmtTeam += oa.sumstmtamt;
                curTeam += oa.sumcurbal;
              });
            });

            data[teamName] = {
              teamName,
              teamId,
              list: [],
              ac: acTeam,
              os: osTeam,
              bal: balTeam,
              cur: curTeam,
              stmt: stmtTeam,
            };
          }

          if (!data[teamName].list.find((l: any) => l.listName === listName)) {
            data[teamName].list.push({
              listName,
              oaList,
              ac,
              os,
              bal,
              cur,
              stmt,
            });
          }

          return data;
        }, {}),
      );

    dataSource.push({
      statusName: status,
      teamList: groupByTeams(teamList),
    });

    return dataSource;
  }

  useEffect(() => {
    async function fetchDataForSearch() {
      const apiCaller = id24Axios(appConfig.apiBaseUrlDebt);
      const res: any = await DashboardService(apiCaller).getBankManager();
      let conDataNew: any = integrateDashboardByStatus(res.result, "new");
      let conDataAction: any = integrateDashboardByStatus(res.result, "action");
      let conDataNoAction: any = integrateDashboardByStatus(res.result, "noAction");
      setDataSource({
        new: conDataNew,
        action: conDataAction,
        noAction: conDataNoAction,
      });
      setLoading(false);
    }

    if (loading) fetchDataForSearch();
  }, [loading]);

  const statusConfig: any = {
    new: {
      label: "New",
      cardBg: "#0056B4",
      tagColor: "#1890FF",
      textColor: "#108ee9",
      avatarBg: "#E1EDF9",
      iconColor: "#035BBD",
    },
    action: {
      label: "Action",
      cardBg: "#70C787",
      tagColor: "#52C41A",
      textColor: "#52C41A",
      avatarBg: "#DEFFCD",
      iconColor: "#52C41A",
    },
    noAction: {
      label: "No-Action",
      cardBg: "#EE5F77",
      tagColor: "#FF4D4F",
      textColor: "#FF4D4F",
      avatarBg: "#FFE2E2",
      iconColor: "#FF4D4F",
    },
  };

  const renderStatusBlock = (status: "new" | "action" | "noAction") => {
    const conf = statusConfig[status];
    const statusData = dataSource[status];
    if (!statusData || statusData.length === 0) return null;
    return statusData.map((newstatus: any, index: any) => (
      <Col span={8} key={status + index}>
        <Row>
          <Col span={24}>
            <Card
              style={{
                backgroundColor: conf.cardBg,
                borderRadius: "5px",
                marginBottom: "10px",
                justifyContent: "center",
                display: "flex",
                gap: "24px",
              }}
            >
              <Space>
                <b style={fontStyleHerder}>{conf.label}</b>
                <Tag style={fontStyleTap} color={conf.tagColor}>
                  <NumberFormat value={newstatus.teamList.length} displayType="text" decimalScale={0} fixedDecimalScale thousandSeparator />
                </Tag>
              </Space>
            </Card>

            {newstatus.teamList.map((teams: any, indexTeam: any) => (
              <Col key={indexTeam}>
                <Collapse
                  defaultActiveKey={["0"]}
                  expandIconPosition="end"
                  style={{ borderRadius: "5px", backgroundColor: "#FFFFFF" }}
                  bordered={false}
                  ghost
                >
                  <Panel
                    key="1"
                    header={
                      <Col span={24}>
                        <Row gutter={[0, 24]}>
                          <Col span={4}></Col>
                          <Col span={18}>
                            <a
                              onClick={() => toDebt(status, teams.teamId, "", "", "")}
                              style={{ fontSize: "18px", color: conf.textColor, marginRight: "5px" }}
                            >
                              <b>{teams.teamName}</b>
                            </a>
                            <Tag style={{ fontSize: "16px", borderRadius: "10px" }} color={conf.tagColor}>
                              <NumberFormat value={teams.list.length} displayType="text" thousandSeparator />
                            </Tag>
                          </Col>
                          <Col span={2}></Col>
                        </Row>

                        <Row>
                          <Col span={4}>
                            <Avatar
                              style={{ backgroundColor: conf.avatarBg }}
                              shape="square"
                              icon={<UserOutlined style={{ color: conf.iconColor }} />}
                            />
                          </Col>
                          <Col span={20} style={{ fontSize: "12px" }}>
                            <div>
                              {`A/C`}
                              <b style={{ marginLeft: "2px" }}>{teams.ac}</b>
                            </div>
                            <div>
                              {`BAL`} <b style={{ marginLeft: "2px" }}>{numberWithCommas(teams.bal)}</b>
                            </div>
                            <div>
                              {`OS`} <b style={{ marginLeft: "2px" }}>{numberWithCommas(teams.os)}</b>
                            </div>
                            <div>
                              {`CUR`} <b style={{ marginLeft: "2px" }}>{numberWithCommas(teams.cur)}</b>
                            </div>
                            <div>
                              {`STMT`} <b style={{ marginLeft: "2px" }}>{numberWithCommas(teams.stmt)}</b>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    }
                  >
                    <Collapse defaultActiveKey={["0"]}>
                      {teams.list.map((list: any, indexList: any) => (
                        <Panel
                          key={indexList}
                          header={
                            <>
                              <Col span={8} style={{ fontSize: "12px" }}>
                                <a style={{ color: "black" }} onClick={() => toDebt(status, teams.teamId, list.listName, "", "")}>
                                  {list.listName}
                                </a>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                {`A/C`} <b>{list.ac}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                {`BAL`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.bal)}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                {`OS`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.os)}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                {`CUR`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.cur)}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                {`STMT`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.stmt)}</b>
                              </Col>
                            </>
                          }
                        >
                          {list.oaList.oalist.map((oa: any, index: any) => (
                            <Row style={fontStyleRow} key={index}>
                              <Col span={7} offset={1}>
                                <a style={{ color: "black" }} onClick={() => toDebt(status, teams.teamId, list.listName, oa.oaname, oa.oaCode)}>
                                  {oa.oaname}
                                </a>
                              </Col>
                              <Col span={6} offset={2}>
                                {`A/C`}
                                <b
                                  style={{
                                    marginLeft: "2px",
                                    color: "#0056B4",
                                  }}
                                >
                                  {oa.cnt}
                                </b>
                              </Col>
                              <Col span={6} offset={2}>
                                {`BAL`}
                                <b style={{ marginLeft: "2px", color: "#0056B4" }}>{numberWithCommas(oa.sumamt)}</b>
                              </Col>
                              <Col span={6} offset={1}>
                                {`OS`}
                                <b style={{ marginLeft: "2px", color: "#0056B4" }}>{numberWithCommas(oa.sumos)}</b>
                              </Col>
                              <Col span={6} offset={3}>
                                {`CUR`}
                                <b style={{ marginLeft: "2px", color: "#0056B4" }}>{numberWithCommas(oa.sumcurbal)}</b>
                              </Col>
                              <Col span={6} offset={2}>
                                {`STMT `}
                                <b style={{ marginLeft: "2px", color: "#0056B4" }}>{numberWithCommas(oa.sumstmtamt)}</b>
                              </Col>
                            </Row>
                          ))}
                        </Panel>
                      ))}
                    </Collapse>
                  </Panel>
                </Collapse>
                <br />
              </Col>
            ))}
          </Col>
        </Row>
      </Col>
    ));
  };

  return loading ? (
    <>
      <div style={{ justifyContent: "center", display: "flex", alignItems: "center", minHeight: "30vh" }}>
        <Spin spinning={loading} tip="Loading" indicator={antIcon} />
      </div>
    </>
  ) : (
    <>
      <Row
        gutter={[
          { xs: 8, sm: 18 },
          { xs: 8, sm: 18 },
        ]}
      >
        {renderStatusBlock("new")}
        {renderStatusBlock("action")}
        {renderStatusBlock("noAction")}
      </Row>
    </>
  );
};
